import React from "react";

function Toast({ title, description, actionUrl, actionLabel }) {
  return (
    <div className="flex flex-col text-ui-text-heading font-body">
      <h1 className="font-medium">{title}</h1>
      {description && <p className="text-xs">{description}</p>}
      {actionUrl && (
        <a
          href={actionUrl}
          className="text-decoration-none border-[1px] rounded-full text-black w-[300px] h-12 flex items-center justify-center"
        >
          {actionLabel} &rarr;
        </a>
      )}
    </div>
  );
}

export default Toast;
